import { ApplicantStatus, ApplicationStatus } from '../graphql/queries';
import type { ReceivedCoapplicantInvitation, RentalApplication, UserStatus } from '../graphql/queries';
import {
  getIsBackgroundReportExpirationInFuture,
  getIsCreditReportExpirationInFuture,
  getIsPaymentValid,
} from './user-statuses';

export function getIsReadOnly(application: RentalApplication) {
  return getIsComplete(application) || getIsWithdrawn(application);
}

export function getIsComplete(application: RentalApplication) {
  return application.status === ApplicantStatus.completed;
}

export function getIsWithdrawn(application: RentalApplication) {
  return application.applicationStatus === ApplicationStatus.withdrawn;
}

export function getIsApproved(application: RentalApplication) {
  return application.applicationStatus === ApplicationStatus.approved;
}

export function getIsDeclined(application: RentalApplication) {
  return application.applicationStatus === ApplicationStatus.declined;
}

export function getIsInProgress(application: RentalApplication) {
  return application.status === ApplicantStatus.pending;
}

export function getIsViewedByLandlord(application: RentalApplication) {
  return !!application.ireneViewedDateTime;
}

export function getInvitations(application: RentalApplication): Array<ReceivedCoapplicantInvitation> {
  const invitations = application.rentalListing?.receivedInvitations ?? [];
  return invitations.filter((invitation) => invitation !== null) as Array<ReceivedCoapplicantInvitation>;
}

export function getCanShareApplication(applications: Array<RentalApplication | null>, userStatuses: Array<UserStatus>) {
  return (
    applications.some(
      (application) =>
        application?.applicationStatus &&
        [
          ApplicationStatus.submitted,
          ApplicationStatus.declined,
          ApplicationStatus.withdrawn,
          ApplicationStatus.approved,
        ].includes(application.applicationStatus),
    ) &&
    getIsPaymentValid(userStatuses) &&
    getIsBackgroundReportExpirationInFuture(userStatuses) &&
    getIsCreditReportExpirationInFuture(userStatuses)
  );
}
